/**
 * Default constants for accessorials
 */

/** Default duration for fuel refills and other time-based operations (in seconds) */
export const DEFAULT_DURATION_SECONDS = 300

/** Default price per minute charged to customers for delay accessorials */
export const DEFAULT_PRICE_PER_MINUTE = 0.33

/** Default pay per minute to drivers for delay accessorials */
export const DEFAULT_PAY_PER_MINUTE = 0.17
